// Vendor imports
const _ = require('lodash')
const React = require('react')

const THROTTLE_FREQUENCY = 66 // ~15 frames per second

function useResizeHeightListener(onHeightChange) {
  if (typeof window === 'undefined') {
    return // Do nothing during server-side render
  }
  const domRef = React.useRef(null)
  const heightRef = React.useRef(null)
  React.useEffect(() => {
    function onResize() {
      if (domRef.current) {
        const newHeight = domRef.current.scrollHeight
        if (newHeight !== heightRef.current) {
          onHeightChange(newHeight)
          heightRef.current = newHeight
        }
      }
    }
    onResize()
    const throttledOnResize = _.throttle(onResize, THROTTLE_FREQUENCY)
    window.addEventListener('resize', throttledOnResize)
    return () => {
      window.removeEventListener('resize', throttledOnResize)
      throttledOnResize.cancel()
    }
  })
  return domRef
}

module.exports = useResizeHeightListener
